export default "__VITE_ASSET__JlDOurRh__"